import type { MouseEvent } from 'react';

export const goToPreviousPage = (): void => {
  window.history.back();
};

export const stopPropagation = (event: MouseEvent): void =>
  event.stopPropagation();

export const joinPath = (base: string, id: string) => `${base}/${id}`;
